import { z } from 'zod'

export const vacancySearchSchema = z.object({
  search: z.string().catch(''),
  categories: z.array(z.coerce.number().int().positive()).catch([]),
  page: z.coerce.number().int().positive().catch(1),
  pageSize: z.coerce
    .number()
    .pipe(z.union([z.literal(10), z.literal(25), z.literal(50)]))
    .catch(25),
  sortBy: z
    .enum(['title', 'places', 'workplace', 'validtill', 'active', 'lastedit'])
    .catch('title'),
  direction: z.enum(['asc', 'desc']).catch('asc'),
})
export const defaultVacancySearch = vacancySearchSchema.parse({})
